import { addStyles } from 'ethcss'
import { grid, IStyles } from '../../../theme'
import { defaultThemeStyles } from '../Range-theme'
import { color } from 'theme/tokens/color'

const rangeVolumeStyles: IStyles = {
    wrapper: {
        ...grid.rowCenter,
        ...grid.w100,
        paddingTop: 24,
        ...grid.pb_microPlus,
    },
    icon: {
        ...grid.p_mini,
    },
    range: {
        ...grid.space,
        position: 'relative',
    },
    counter: {
        position: 'absolute',
        color: `var(--var-module-ui-component-range-style-counter, ${defaultThemeStyles.counter})`,
        transform: 'translate(-50%)',
        top: -20,
    },
    counterWhite: {
        color: color.iconWhiteHigh,
    },
    disabled: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
}

addStyles(rangeVolumeStyles)
export default rangeVolumeStyles
